import { Pipe, PipeTransform } from '@angular/core';
import {
    OrganisationDto,
    SimpleOrganisationDto
} from '@flyfreely-portal-ui/flyfreely';

@Pipe({
    name: 'formatOrganisation'
})
export class FormatOrganisationPipe implements PipeTransform {
    transform(
        value: OrganisationDto | SimpleOrganisationDto,
        ...args: unknown[]
    ): string | undefined {
        return value?.name;
    }
}
